import { render, staticRenderFns } from "./RecipesCost.vue?vue&type=template&id=502d5b36&scoped=true"
import script from "./RecipesCost.vue?vue&type=script&lang=ts"
export * from "./RecipesCost.vue?vue&type=script&lang=ts"
import style0 from "./RecipesCost.vue?vue&type=style&index=0&id=502d5b36&prod&scoped=true&lang=css"
import style1 from "./RecipesCost.vue?vue&type=style&index=1&id=502d5b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d5b36",
  null
  
)

export default component.exports